import { useIntl } from "react-intl";

const HeartbeatMonitoring = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.HeartbeatMonitoring.header",
            defaultMessage: "Heartbeat monitoring"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.HeartbeatMonitoring.body",
            defaultMessage:
                "Ensure that alerting works end to end through passive monitoring of the systems forwarding alerts to Jira Service Management. JSM notifies you of any communication gaps with your system after specified time intervals."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default HeartbeatMonitoring;
